export default __webpack_public_path__ + "static/media/right_arrow.8b9da6c6.svg";